import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  Label,
  Row,
  Col,
  Button,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { submitAnswer } from "utils/apiService";

const AssignmentEditModal = ({ isOpen, toggle, assignment, refreshData }) => {
  /* const submitAnswer = async (formData) => {
    try {
      const token = localStorage.getItem("token") || "";

      const response = await axios.post(
        "http://localhost:8080/services/submitAnswer",
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Success:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error submitting answer:");
      throw error;
    }
  }; */

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: assignment?.id || "",
      student_name: assignment?.student_name || "",
      question: assignment?.description || "",
      question_file: assignment?.doc_base64 || "",
      question_file_mimetype: assignment?.doc_mimetype || "",
      answer: assignment?.answer_description || "",
      answer_file: null,
      answer_file_base64: assignment?.answer_base64 || "",
      answer_file_mimetype: assignment?.answer_mimetype || "",
    },
    validationSchema: Yup.object({
      answer: Yup.string().required("Answer is required"),
      answer_file: Yup.mixed().required("File upload is required"),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("assignmentId", values.id);
        formData.append("answer_description", values.answer);
        formData.append("serviceId", assignment?.service_id);
        formData.append("studentId", assignment?.student_id);

        if (values.answer_file) {
          formData.append("file", values.answer_file);
        }
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }
        await submitAnswer(formData);

        toast.success("Answer submitted successfully!");
        await refreshData();
        toggle();
      } catch (err) {
        console.error("Error submitting assignment:", err);
        toast.error("Failed to submit answer");
      }
    },
  });

  const isFormValid =
    formik.values.answer.trim() !== "" && formik.values.answer_file !== null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" centered>
      <ModalHeader toggle={toggle}>Edit Assignment</ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            {/* Student Name */}
            <Col xs={12}>
              <div className="mb-3">
                <Label>Student Name</Label>
                <Input
                  type="text"
                  value={formik.values.student_name}
                  disabled
                />
              </div>
            </Col>

            {/* Question */}
            <Col xs={12}>
              <div className="mb-3">
                <Label>Question</Label>
                <Input type="text" value={formik.values.question} disabled />
              </div>
            </Col>

            {/* Question File */}
            <Col xs={12}>
              <div className="mb-3">
                <Label>Question File</Label>
                {formik.values.question_file ? (
                  <button
                    className="btn btn-link text-primary"
                    type="button"
                    onClick={() => {
                      const fileUrl = `data:${formik.values.question_file_mimetype};base64,${formik.values.question_file}`;
                      const newTab = window.open();
                      if (newTab) {
                        newTab.document.write(
                          `<iframe src="${fileUrl}" width="100%" height="100%" style="border:none;"></iframe>`
                        );
                        newTab.document.close();
                      }
                    }}
                  >
                    📄 View File
                  </button>
                ) : (
                  "No file"
                )}
              </div>
            </Col>

            {/* Answer (Multiline) */}
            <Col xs={12}>
              <div className="mb-3">
                <Label>Answer</Label>
                <Input
                  name="answer"
                  type="textarea"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.answer}
                  invalid={formik.touched.answer && !!formik.errors.answer}
                />
                {formik.touched.answer && formik.errors.answer && (
                  <FormFeedback>{String(formik.errors.answer)}</FormFeedback>
                )}
              </div>
            </Col>

            {/* Upload Assignment */}
            <Col xs={12}>
              <div className="mb-3">
                <Label>Upload Assignment Solution</Label>
                <Input
                  name="answer_file"
                  type="file"
                  onChange={(event) => {
                    const file = event.currentTarget.files?.[0];
                    if (file) {
                      formik.setFieldValue("answer_file", file);
                      /* console.log("FILE", file); */
                    }
                  }}
                  invalid={
                    formik.touched.answer_file && !!formik.errors.answer_file
                  }
                />
                {formik.touched.answer_file && formik.errors.answer_file && (
                  <FormFeedback>
                    {String(formik.errors.answer_file)}
                  </FormFeedback>
                )}
              </div>
            </Col>

            {/* Existing Answer File */}
            {formik.values.answer_file_base64 && (
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Existing Answer File</Label>
                  <button
                    className="btn btn-link text-primary"
                    type="button"
                    onClick={() => {
                      const fileUrl = `data:${formik.values.answer_file_mimetype};base64,${formik.values.answer_file_base64}`;
                      const newTab = window.open();
                      if (newTab) {
                        newTab.document.write(
                          `<iframe src="${fileUrl}" width="100%" height="100%" style="border:none;"></iframe>`
                        );
                        newTab.document.close();
                      }
                    }}
                  >
                    📄 View Answer File
                  </button>
                </div>
              </Col>
            )}
          </Row>

          <div className="text-end">
            <Button type="submit" color="success" disabled={!isFormValid}>
              Submit
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AssignmentEditModal;
